// in ./ResetViewsButton.js
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, crudUpdateMany, startUndoable, crudUpdate } from 'react-admin';

class MovetoHoldButton extends Component {
    handleClick = () => {
        const {  basePath, resource, selectedIds, startUndoable } = this.props;
        startUndoable(
            crudUpdateMany(resource, selectedIds, { status: "hold" }, basePath)
        );
    };

    render() {
        return (
            <Button label="Move to Hold" onClick={this.handleClick} />
        );
    }
}

export default connect(undefined, { startUndoable })(MovetoHoldButton);